exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vertically-center[data-v-53c51106]{position:absolute;left:0;right:0;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", ""]);

// exports
